import { ActivatedRoute } from '@angular/router';
import { IAutorizacoes } from './../../../interfaces/token/IAutorizacoes';
import { AuthenticationService } from './../../../services/authentication/authentication.service';
import { Component, Inject, OnInit } from '@angular/core';
import { Environment } from 'src/app/types';
import { ENVIRONMENT } from 'src/app/constants';

@Component({
  selector: 'app-novo-suprimento-conclusion',
  templateUrl: './novo-suprimento-conclusion.component.html',
  styleUrls: ['./novo-suprimento-conclusion.component.scss']
})
export class NovoSuprimentoConclusionComponent implements OnInit {
  codigoSuprimento: string;
  autorizacoes: IAutorizacoes;

  constructor(
    private authService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    @Inject(ENVIRONMENT) public environment: Environment
  ) {}

  ngOnInit() {
    this.autorizacoes = this.authService.obterToken()['autorizacoes'];
    this.codigoSuprimento = this.activatedRoute.snapshot.params['codigo'];
  }
}
